<template>
  <div>
    <div class="mt-5 mx-10 d-flex justify-space-between">
      NIT-BI
      <v-menu offset-y>
        <template v-slot:activator="{ on, attrs }">
          <div
            v-bind="attrs"
            v-on="on"
            class="d-flex align-center mt-3 pl-5 pr-2 py-2 rounded"
            style="
              background: white;
              box-shadow: 0px 8px 18px rgba(82, 111, 151, 0.06);
              height: 42px;
            "
            @click="menuOpen = !menuOpen"
          >
            <span
              class="mr-5 text-capitalize darkBlue--text font-weight-black text-body-2"
              >{{ userName }}</span
            >
            <v-icon color="#505D6F" v-if="!menuOpen">mdi-chevron-down</v-icon>
            <v-icon color="#505D6F" v-else>mdi-chevron-up</v-icon>
          </div>
        </template>
        <v-list dense>
          <v-list-item @click="goTo('/login')">
            <v-list-item-title class="font-weight-bold darkBlue--text"
              >Logout</v-list-item-title
            >
          </v-list-item>
         
        </v-list>
      </v-menu>
    </div>

    <v-container class="bg-surface-variant">
      <v-expansion-panels>
        <v-expansion-panel v-model="panel">
          <v-expansion-panel-header>  {{this.clinetlistItemSelected.clientName}}</v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-row>
              <v-col md="12" lg="12" xl="12">
                <v-sheet>
                  <v-card elevation="2" outlined tile>
                    <v-card-text>
                      <v-row>
                        <v-col class="d-flex" cols="12" md="12" lg="12" xl="6">
                          <v-select
                            v-model="clinetlistItemSelected"
                            :items="this.clinetlistItem"
                            item-text="clientName"
                            item-value="clientID"
                            label="Standard"
                            hide-details
                            prepend-icon="mdi-map"
                            single-line
                            return-object
                            @change="OnClientChange"
                          ></v-select>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col class="d-flex" cols="12" md="12" lg="12" xl="6">
                          <v-menu
                            ref="menu"
                            v-model="menu"
                            :close-on-content-click="false"
                            :return-value.sync="sessiondate"
                            transition="scale-transition"
                            offset-y
                            min-width="auto"
                          >
                            <template v-slot:activator="{ on, attrs }">
                              <v-text-field
                                v-model="sessiondate"
                                label="Picker in menu"
                                prepend-icon="mdi-calendar"
                                readonly
                                v-bind="attrs"
                                v-on="on"
                              ></v-text-field>
                            </template>
                            <v-date-picker
                              v-model="sessiondate"
                              no-title
                              scrollable
                            >
                              <v-spacer></v-spacer>
                              <v-btn text color="primary" @click="menu = false">
                                Cancel
                              </v-btn>
                              <v-btn
                                text
                                color="primary"
                                @click="
                                  $refs.menu.save(sessiondate),
                                    changeclanderdate()
                                "
                              >
                                OK
                              </v-btn>
                            </v-date-picker>
                          </v-menu></v-col
                        >
                      </v-row>
                      <v-row>
                        <v-col class="d-flex" cols="12" md="12" lg="12" xl="6">
                          <v-select
                            v-model="SessionlistItemSelected"
                            :items="this.SessionlistItem"
                            item-text="sessionDate"
                            item-value="sessionID"
                            label="Standard"
                            hide-details
                            prepend-icon="mdi-map"
                            multiple
                          ></v-select>
                       
                        </v-col>
                      </v-row>
                      <v-row
                        ><v-col
                          ><v-btn
                            depressed
                            color="primary"
                            @click="clickOnViewbutton()"
                          >
                            View
                          </v-btn></v-col
                        ></v-row
                      >
                    </v-card-text>
                  </v-card>
                </v-sheet>
              </v-col>
            </v-row>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </v-container>
    <v-container class="bg-surface-variant">
      <v-divider></v-divider>
     
     
      <v-row v-for="item in transactionlistItem" :key="item">
        <v-col cols="12" md="12" lg="12" xl="6">
          <v-sheet>
            <v-card elevation="2" outlined tile>
              <v-card-title>Transaction Number :- {{item.transactionID}}</v-card-title>
              <v-card-text>
           
             <div>{{item.screenName}}</div> 
             <div>NoOfTickets:-{{item.noOfTickets}}</div> 
             <div>Seat/TicketType:-{{item.seatnumbers}}</div> 
             <div>ShowTime:-{{item.starttime}}</div> 
             <div>Name:-{{item.name}}</div> 
             <div>Phone:-{{item.phone}}</div> 
             <div>Phone:-{{item.emailID}}</div> 
             <div>TransactionCost:-Rs.{{item.transactionCost}}</div> 
                </v-card-text>
            </v-card>
          </v-sheet>
        </v-col>
      </v-row>
      <!-- {{this.transactionlistItem}}-->
    </v-container>
  </div>
</template>

<script>
import axios from "axios";
import Vue from "vue";
import VueAxios from "vue-axios";
import apifactory from "../../../apis/apifactory";

Vue.use(VueAxios, axios);
export default {
  name: "ExtraAuth",
  data: () => ({
    panel:1,
    userid: null,
    clinetlistItem: [],
    clinetlistItemSelected: null,
    SessionlistItem: null,
    SessionlistItemSelected: null,
    transactionlistItem: null,
   
    appItemsprefered: "",
    sessiondate: null,
    msg: "",
    menuOpen: false,
    items: ["Foo", "Bar", "Fizz", "Buzz"],
  }),
  computed: {
    userName() {
      return localStorage.getItem("SET_USERNAME");
    },
  },
  mounted() {
   // this.getapitest();
    this.getclinetlist();
   
    //this.getloginuserapp();
  },
  methods: {
    OnClientChange(){
      this.SessionlistItem=[];
      this.SessionlistItemSelected=[];
      this.transactionlistItem=[]
    },
    changeclanderdate() {
      //alert(JSON.stringify(this.sessiondate));
      //var selectedclient=this.clinetlistItemSelected.ClientID;
      //alert(selectedclient);
      this.getsessionlist();
    },
    clickOnViewbutton(){
      if(this.SessionlistItemSelected == null)
      {
alert("Please select the Session");

      }
      else{  this.gettransactions();}
    
    },
    getsessionlist() {
      this.SessionlistItem = null;
      this.SessionlistItemSelected = null;
      apifactory
        .getsessionlistbydate(
          this.sessiondate,
          this.clinetlistItemSelected.clientID
        )
        .then((res) => {
          //alert(JSON.stringify(res));
          this.SessionlistItem = res.data;
        })
        .catch(function (error) {
          alert(JSON.stringify(error));
        });
    },
    checkauth() {
      this.getauthdata();
      this.loginusername = "";
    },
    getstoragevalues() {
      this.userid = localStorage.getItem("SET_USERID");
    },
    getloginuserapp() {
      apifactory
        .getloginuserapps(this.userid)
        .then((res) => {
          // alert(res.status);

          if (res.status != 200) {
            alert(res.data.message);
          } else {
            this.appItems = res.data;
          }
        })
        .catch(function (error) {
          console.warn(error);
        });
    },

    goTo(url) {
      return this.$router.push(url);
    },
    openurl(url, app_id) {
      // let newurl="http://localhost:8081/#/ExtraAuth" +url;
      // eslint-disable-next-line no-unused-vars
      let appid = app_id;
      let newurl = url;
      window.location.href = newurl;
    },
    getclinetlist() {
      apifactory
        .getclinetsbyuserid()
        .then((res) => {
          //alert(JSON.stringify(res));
          this.clinetlistItem = res.data;
          if(this.clinetlistItem.length >0)
          {
            this.clinetlistItemSelected=this.clinetlistItem[0];
          }
         
          
        })
        .catch(function (error) {
          alert(JSON.stringify(error));
        });
    },
    getapitest() {
      //alert("getapitest");
      
    },
    gettransactions() {
      apifactory
        .gettransactionbysession(
          this.SessionlistItemSelected,
          this.clinetlistItemSelected.clientID
        )
        .then((res) => {
         // alert(JSON.stringify(res));
          this.transactionlistItem=res.data;
        })
        .catch(function (error) {
          alert(JSON.stringify(error));
        });
    },
  },
};
</script>

<style scoped>
.linkdiv {
  cursor: pointer;
}
</style>
